import React, { createRef, useRef } from 'react'
import Cards from '../../components/cards'
import Main from '../../components/main'
import BackButton from '../../components/backButton'
import FilterWrapper from '../../components/Filter'
import { useState } from 'react'
import AuctionDataMoreInfo from '../modal/auctionDataMoreInfo'
import { dateTime_MWORD } from '../../utils/dateFormatDDMMYYYY'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { useEffect } from 'react'
import ModalWrapper from '../../components/previewModal'
import Loader from '../../components/Loader/Loader'
import { useNavigate } from 'react-router-dom'
import {
    submitBidRequest,
    submitBidReset,
} from '../../store/actions/submitBidAction'
import { checkUndefinedShow_NA } from '../../utils/checkUndefinedShow_NA'
import { FaRegImages } from 'react-icons/fa'
import { NoImageAvailable } from '../../components/noImageAvailable/noImageAvailable'
import ImageSlideModal from '../modal/imageSlideModal'
import { checkValidNumberWithoutDec } from '../../utils/regexValidations'
import urlContain from '../../utils/urlContain'
import { auctionInvListReset } from '../../store/actions/auctionInvAction'

export default function WebViewAutionData({ data }) {
    const inputRefs = useRef([])
    const [showModal, setShowModal] = useState(false)
    const [imageSlideShow, setImageSlideShow] = useState(false)
    const [currentIndex, setCurrentIndex] = useState('')
    const [modalData, setModalData] = useState([])
    const [imageData, setImageData] = useState([])
    const [disable, setDisable] = useState({})
    const navigate = useNavigate()
    const [price, setPrice] = useState({})
    const [isWinningBid, setIsWinningBid] = useState({})
    const [attemptCount, setAttemptCount] = useState({})

    const dispatch = useDispatch()
    const loginObj = useSelector((state) => state.loginReducer)
    const bidObj = useSelector((state) => state.submitBidReducer)
    const { loginResult } = loginObj
    const { loading, resBidSubmit, error } = bidObj

    const [selectedState, setSelectedState] = useState('All')

    const handleStateChange = (event) => {
        setSelectedState(event.target.value)
    }

    const stateList = [
        'All',
        ...[...new Set(data?.map((item) => item.raw_data.state))],
    ]

    const filteredData =
        selectedState === 'All'
            ? data
            : data.filter((item) => item.raw_data.state === selectedState)

    function status_check(item) {
        if (!item['status']) {
            if (
                item['bid_status'] === 'accepted' &&
                item['bid_price'] &&
                item['bid_price'] !== ''
            ) {
                return {
                    disable: true,
                    backgroundColor: 'green',
                    buttonLabel: 'ACCEPTED',
                }
            } else if (
                item['bid_status'] === 'new_bid' &&
                item['bid_price'] &&
                item['bid_price'] !== '' &&
                (isWinningBid[item['id']] === false ||
                    item['is_winning_bid'] === false)
            ) {
                return {
                    disable: false,
                    backgroundColor: '#F37021',
                    buttonLabel: 'REBID',
                    color: '#FFFFFF',
                }
            } else if (
                item['bid_status'] === 'rejected' &&
                item['bid_price'] &&
                item['bid_price'] !== '' &&
                disable[item['id']] &&
                isWinningBid[item['id']] === false
            ) {
                return {
                    disable: false,
                    backgroundColor: '#F37021',
                    buttonLabel: 'REBID',
                    color: '#FFFFFF',
                }
            } else if (
                item['bid_status'] === 'rejected' &&
                item['bid_price'] &&
                item['bid_price'] !== '' &&
                disable[item['id']] &&
                isWinningBid[item['id']]
            ) {
                return {
                    disable: true,
                    backgroundColor: 'yellow',
                    buttonLabel: 'IN REVIEW',
                    color: '#000000',
                }
            } else if (
                item['bid_status'] === 'rejected' &&
                item['bid_price'] &&
                item['bid_price'] !== '' &&
                (item['is_winning_bid'] ||
                    item['is_winning_bid'] === false ||
                    isWinningBid[item['id']] ||
                    isWinningBid[item['id']] === false)
            ) {
                return {
                    disable: false,
                    backgroundColor: 'red',
                    buttonLabel: 'REJECTED, REBID',
                }
            } else if (
                (!item['bid_status'] ||
                    item['bid_status'] ||
                    item['bid_status'] === 'new_bid') &&
                (item['bid_price'] || !item['bid_price']) &&
                (item['bid_price'] !== '' || item['bid_price'] === '') &&
                (isWinningBid[item['id']] || item['is_winning_bid'])
            ) {
                return {
                    disable: true,
                    backgroundColor: 'yellow',
                    buttonLabel: 'IN REVIEW',
                    color: '#000000',
                }
            } else if (
                (!item['bid_status'] || item['bid_status']) &&
                (item['bid_price'] || !item['bid_price']) &&
                (item['bid_price'] !== '' || item['bid_price'] === '') &&
                (isWinningBid[item['id']] === false ||
                    item['is_winning_bid'] === false)
            ) {
                return {
                    disable: false,
                    backgroundColor: '#F37021',
                    buttonLabel: 'REBID',
                    color: '#FFFFFF',
                }
            } else {
                return null
            }
        } else if (item['status'] && item['bid_status'] === 'accepted') {
            return {
                disable: true,
                backgroundColor: 'green',
                buttonLabel: 'ACCEPTED',
            }
        } else if (item['status'] && item['bid_status'] === 'rejected') {
            return {
                disable: true,
                backgroundColor: 'red',
                buttonLabel: 'REJECTED',
            }
        } else if (
            item['status'] &&
            !item['bid_price'] &&
            !item['bid_status']
        ) {
            return {
                disable: true,
                backgroundColor: '#9E9E9B',
                buttonLabel: 'BIDDING CLOSED',
            }
        } else {
            return null
        }
    }

    function formatNumberToLac(number) {
        if (number >= 100000) {
            const lacValue = Math.floor(number) / 100000
            return `${lacValue} L`
        }
        return (Math.floor(number) || '').toLocaleString()
    }

    useEffect(() => {
        if (data) {
            let priceVar = price,
                checkWinnigBid = isWinningBid,
                checkAttemptCount = attemptCount
            inputRefs.current = []
            data?.forEach((element, index) => {
                priceVar = {
                    ...priceVar,
                    [`bid_price_${index}`]: Number.parseFloat(
                        element['bid_price']
                    ).toFixed(0),
                }
                element.hasOwnProperty('is_winning_bid') &&
                    (checkWinnigBid = {
                        ...checkWinnigBid,
                        [element.id]: element?.is_winning_bid,
                    })
                element?.bidding_count &&
                    (checkAttemptCount = {
                        ...checkAttemptCount,
                        [element.id]: element?.bidding_count,
                    })
                const inputRef = createRef()
                inputRefs.current.push(inputRef)
            })
            setIsWinningBid(checkWinnigBid)
            setAttemptCount(checkAttemptCount)
            setPrice(priceVar)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (resBidSubmit) {
            if (resBidSubmit.status) {
                setDisable((prev) => ({
                    ...prev,
                    [resBidSubmit?.data?.auction_product_fk_id]: true,
                }))
                setIsWinningBid((prev) => ({
                    ...prev,
                    [resBidSubmit?.data?.auction_product_fk_id]:
                        resBidSubmit?.data?.is_winning_bid,
                }))
                setAttemptCount((prev) => ({
                    ...prev,
                    [resBidSubmit?.data?.auction_product_fk_id]:
                        resBidSubmit?.data?.bidding_count,
                }))
            }
            Swal.fire({
                icon: resBidSubmit?.status ? 'success' : 'info',
                confirmButtonColor: '#652078',
                text: resBidSubmit?.status
                    ? 'Bid submitted successfully'
                    : resBidSubmit?.message,
            }).then((res) => {
                if (res) {
                    dispatch(submitBidReset())
                }
            })
        } else if (error?.response?.status === 400) {
            Swal.fire({
                icon: 'info',
                confirmButtonColor: '#652078',
                text: error?.response?.data?.message,
            }).then((res) => {
                if (res) {
                    dispatch(submitBidReset())
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resBidSubmit, error?.response])

    const modalToggal = (item, index) => {
        setShowModal((prev) => !prev)
        setCurrentIndex(index)
        setModalData(item)
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setPrice((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleSubmitbid = (e, bidPrice, product_id, index, itemJson) => {
        e.preventDefault()

        if (
            bidPrice &&
            bidPrice !== '' &&
            checkValidNumberWithoutDec(bidPrice) &&
            bidPrice > 0
        ) {
            const toFixedZeroPrice = Number.parseFloat(
                itemJson['bid_price']
            ).toFixed(0)
            const inputRef = inputRefs.current[index]
            if (
                inputRef &&
                inputRef.current &&
                bidPrice === toFixedZeroPrice &&
                itemJson['bidding_count'] !== itemJson['max_bid_count']
            ) {
                inputRef.current.focus()
                return -1
            }

            let reqBid = {
                user_id: loginResult?.data?.user_id,
                price: bidPrice,
                product_id: product_id,
            }
            dispatch(submitBidRequest({ reqBid }))
        } else {
            Swal.fire({
                icon: 'error',
                confirmButtonColor: '#652078',
                text: 'Please fill valid amount. Bid cannot be a zero, negative or decimal value',
            }).then((res) => {
                if (res) {
                }
            })
        }
    }

    const imageSlideShowHandler = (imageArray, item, index) => {
        if (imageArray) {
            setImageData(imageArray)
            setModalData(item)
        }
        setImageSlideShow((prev) => !prev)
    }

    const backFn = () => {
        dispatch(auctionInvListReset())
        navigate(`/auctionListPage`)
    }

    // onError={event => {
    //   event.target.src = "../assets/tractor_image1.png"
    //   event.onerror = null
    // }}

    const attemptStyle = {
        height: '14px',
        minHeight: '14px',
        color: 'var(--text-brand-text, #652278)',
        textAlign: 'right',
        fontSize: '12px',
        fontWeight: '400',
    }

    const winLoseIconFn = (id) => {
        if (Object.keys(isWinningBid).length > 0 && isWinningBid[id]) {
            return (
                <p
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1px',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#007A29',
                    }}
                >
                    Winning Bid{' '}
                    <img src="../assets/icons/thumpsup_green.svg" alt="" />
                </p>
            )
        } else if (isWinningBid[id] === false) {
            return (
                <p
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1px',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#C82733',
                    }}
                >
                    Loosing Bid{' '}
                    <img src="../assets/icons/thumpsdown_red.svg" alt="" />{' '}
                </p>
            )
        } else {
            return null
        }
    }

    const viewImageButtonStyle = {
        position: 'absolute',
        display: 'flex',
        width: '134px',
        height: '32px',
        padding: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '6px',
        background: '#FFF',
        color: '#F37021',
        fontSize: '14px',
        fontWeight: '700',
        textDecoration: 'none',
        bottom: '8px',
        cursor: 'pointer',
    }

    const inputState = {
        height: '50px',
        width: '250px',
        fontSize: '18px',
        padding: '10px 16px',
        borderRadius: '10px',
        border: '0',
        outline: '1px solid',
        borderRight: '16px solid transparent',
    }

    return (
        <>
            <Main>
                <BackButton>
                    <BackButton.IconTextConatiner
                        onClick={() => backFn()}
                        style={{ width: '120px', cursor: 'pointer' }}
                    >
                        <BackButton.Icon
                            src="../assets/arrow/arrow_left.svg"
                            alt="arrow_left"
                        />
                        <BackButton.Text>Back to Listing</BackButton.Text>
                    </BackButton.IconTextConatiner>
                </BackButton>
                <FilterWrapper>
                    <label style={{ width: '250px' }}>State</label>
                    <select
                        id="state-filter"
                        value={selectedState}
                        onChange={handleStateChange}
                        style={inputState}
                    >
                        {stateList?.map((role, index) => (
                            <option key={index} value={role}>
                                {role}
                            </option>
                        ))}
                    </select>
                </FilterWrapper>
                <Cards>
                    {filteredData?.map((item, index) => (
                        <div style={{ maxWidth: '525px' }} key={index}>
                            <Cards.Card>
                                <Cards.BasicInfoContainer>
                                    {item?.['raw_data']?.hasOwnProperty(
                                        'images'
                                    ) &&
                                    (item?.['raw_data']?.images || '').length >
                                        0 ? (
                                        <Cards.ImageButtonWrapper>
                                            {item?.['raw_data']?.hasOwnProperty(
                                                'images'
                                            ) &&
                                            item?.['raw_data']?.[
                                                'images'
                                            ][0] !== '' ? (
                                                <Cards.Image
                                                    src={urlContain(
                                                        item?.['raw_data']?.[
                                                            'images'
                                                        ][0]
                                                    )}
                                                    alt="tractor image"
                                                />
                                            ) : (
                                                <NoImageAvailable
                                                    margin="0"
                                                    minHeight="162px"
                                                    minWidth="150px"
                                                />
                                            )}
                                            <div
                                                style={viewImageButtonStyle}
                                                onClick={() =>
                                                    imageSlideShowHandler(
                                                        item?.['raw_data']
                                                            ?.images,
                                                        item,
                                                        index
                                                    )
                                                }
                                            >
                                                <FaRegImages
                                                    style={{
                                                        height: '18px',
                                                        width: '18px',
                                                    }}
                                                />
                                                View Images
                                            </div>
                                        </Cards.ImageButtonWrapper>
                                    ) : !item?.['raw_data']?.hasOwnProperty(
                                          'images'
                                      ) &&
                                      (item?.['raw_data']?.images || '')
                                          .length === 0 &&
                                      item?.['raw_data']?.hasOwnProperty(
                                          'images'
                                      ) &&
                                      item?.['raw_data']?.['images'][0] !==
                                          '' ? (
                                        <Cards.ImageButtonWrapper>
                                            <Cards.Image
                                                src={urlContain(
                                                    item?.['raw_data']?.[
                                                        'images'
                                                    ][0]
                                                )}
                                                alt="tractor image"
                                            />
                                        </Cards.ImageButtonWrapper>
                                    ) : (
                                        <NoImageAvailable
                                            minHeight="150px"
                                            minWidth="150px"
                                        />
                                    )}

                                    <div style={{ width: '100%' }}>
                                        <Cards.TitleContainer>
                                            <Cards.TextContainer>
                                                <Cards.Title>
                                                    {
                                                        item?.['raw_data']?.[
                                                            'make'
                                                        ]
                                                    }{' '}
                                                    {
                                                        item?.['raw_data']?.[
                                                            'model'
                                                        ]
                                                    }
                                                </Cards.Title>
                                                <Cards.SmallText>
                                                    Brand:{' '}
                                                    {
                                                        item?.['raw_data']?.[
                                                            'make'
                                                        ]
                                                    }
                                                </Cards.SmallText>
                                            </Cards.TextContainer>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Cards.MoreInfoButton
                                                    onClick={() =>
                                                        modalToggal(item, index)
                                                    }
                                                >
                                                    MORE INFO
                                                    <img
                                                        src="../assets/icons/info.svg"
                                                        alt="info"
                                                    />
                                                </Cards.MoreInfoButton>
                                            </div>
                                        </Cards.TitleContainer>
                                        <Cards.BasicInfoMainContainer>
                                            <Cards.IconTextContainer>
                                                <Cards.IconContainer>
                                                    <Cards.Icon
                                                        src="../assets/icons/Ruppe_coin.svg"
                                                        alt="Ruppe_coin"
                                                    />
                                                </Cards.IconContainer>
                                                <Cards.TextLabelContainer>
                                                    <Cards.Price>
                                                        {checkUndefinedShow_NA(
                                                            formatNumberToLac(
                                                                item?.[
                                                                    'raw_data'
                                                                ]?.[
                                                                    'base_price'
                                                                ]
                                                            )
                                                        )}
                                                    </Cards.Price>
                                                </Cards.TextLabelContainer>
                                            </Cards.IconTextContainer>
                                            <Cards.IconTextContainer>
                                                <Cards.IconContainer>
                                                    <Cards.Icon
                                                        src="../assets/icons/bank.svg"
                                                        alt="bank"
                                                    />
                                                </Cards.IconContainer>
                                                <Cards.TextLabelContainer>
                                                    <Cards.Text>
                                                        {checkUndefinedShow_NA(
                                                            dateTime_MWORD(
                                                                item?.[
                                                                    'raw_data'
                                                                ]?.['repo_date']
                                                            )
                                                        )}
                                                    </Cards.Text>
                                                    <Cards.Label>
                                                        Repossessed
                                                    </Cards.Label>
                                                </Cards.TextLabelContainer>
                                            </Cards.IconTextContainer>
                                            <Cards.IconTextContainer>
                                                <Cards.IconContainer>
                                                    <Cards.Icon
                                                        src="../assets/icons/calendar.svg"
                                                        alt="calendar"
                                                    />
                                                </Cards.IconContainer>
                                                <Cards.TextLabelContainer>
                                                    <Cards.Text>
                                                        {checkUndefinedShow_NA(
                                                            item?.[
                                                                'raw_data'
                                                            ]?.['make_year']
                                                        )}
                                                    </Cards.Text>
                                                    <Cards.Label>
                                                        Manufacturing
                                                    </Cards.Label>
                                                </Cards.TextLabelContainer>
                                            </Cards.IconTextContainer>
                                            <Cards.IconTextContainer>
                                                <Cards.IconContainer>
                                                    <Cards.Icon
                                                        src="../assets/icons/Location.svg"
                                                        alt="Location"
                                                    />
                                                </Cards.IconContainer>
                                                <Cards.TextLabelContainer>
                                                    <Cards.Label>
                                                        {
                                                            item?.[
                                                                'raw_data'
                                                            ]?.['yard_location']
                                                        }
                                                        ,
                                                    </Cards.Label>
                                                    <Cards.Label>
                                                        {
                                                            item?.[
                                                                'raw_data'
                                                            ]?.['state']
                                                        }
                                                    </Cards.Label>
                                                </Cards.TextLabelContainer>
                                            </Cards.IconTextContainer>
                                        </Cards.BasicInfoMainContainer>
                                    </div>
                                </Cards.BasicInfoContainer>
                                <div style={attemptStyle}>
                                    {!item['status'] ? (
                                        <span>
                                            {attemptCount[item['id']]
                                                ? `${Math.abs(
                                                      attemptCount[item['id']] -
                                                          item['max_bid_count']
                                                  )} ${
                                                      Math.abs(
                                                          attemptCount[
                                                              item['id']
                                                          ] -
                                                              item[
                                                                  'max_bid_count'
                                                              ]
                                                      ) <= 1
                                                          ? `Attempt`
                                                          : `Attempts`
                                                  } Left`
                                                : `${item['max_bid_count']} Attempts Left`}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <Cards.ButtonContainer>
                                    {item?.['raw_data']?.[
                                        'Link of Vehicle Pictures(Only vehicle pictures)'
                                    ] && (
                                        <Cards.ReportLink
                                            href={
                                                item?.['raw_data']?.[
                                                    'Link of Vehicle Pictures(Only vehicle pictures)'
                                                ]
                                            }
                                            target="_blank"
                                        >
                                            <img
                                                src="../assets/icons/report.svg"
                                                alt="report"
                                            />
                                            AUDIT REPORT
                                        </Cards.ReportLink>
                                    )}
                                    <Cards.InputButtonContainer>
                                        <Cards.InputIconContainer>
                                            <Cards.RupeeText>₹</Cards.RupeeText>
                                            <Cards.Input
                                                type="number"
                                                id={`bid_price_${index}`}
                                                name={`bid_price_${index}`}
                                                childRef={
                                                    inputRefs.current[index]
                                                }
                                                value={
                                                    price[`bid_price_${index}`]
                                                        ? price[
                                                              `bid_price_${index}`
                                                          ]
                                                        : ''
                                                }
                                                disabled={
                                                    status_check(item)
                                                        ? status_check(item)
                                                              .disable
                                                        : false
                                                }
                                                onChange={(e) =>
                                                    handleChange(e)
                                                }
                                                width={
                                                    winLoseIconFn(item['id'])
                                                        ? '74px'
                                                        : null
                                                }
                                            />
                                            {winLoseIconFn(item['id']) &&
                                                !item['status'] && (
                                                    <div
                                                        style={{
                                                            width: '96px',
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            alignItems: 'start',
                                                        }}
                                                    >
                                                        {winLoseIconFn(
                                                            item['id']
                                                        )}
                                                    </div>
                                                )}
                                        </Cards.InputIconContainer>
                                        <Cards.Button
                                            onClick={(e) =>
                                                handleSubmitbid(
                                                    e,
                                                    price[`bid_price_${index}`],
                                                    item['id'],
                                                    index,
                                                    item
                                                )
                                            }
                                            color={status_check(item)?.color}
                                            backgroundColor={
                                                status_check(item)
                                                    ?.backgroundColor
                                            }
                                            disabled={
                                                status_check(item)
                                                    ? status_check(item).disable
                                                    : false
                                            }
                                            width={
                                                winLoseIconFn(item['id'])
                                                    ? '70%'
                                                    : null
                                            }
                                        >
                                            {status_check(item)
                                                ? status_check(item).buttonLabel
                                                : 'BID PRICE'}
                                        </Cards.Button>
                                    </Cards.InputButtonContainer>
                                </Cards.ButtonContainer>
                            </Cards.Card>
                        </div>
                    ))}
                </Cards>
            </Main>
            {showModal && (
                <AuctionDataMoreInfo
                    setShowModal={setShowModal}
                    modalData={modalData}
                    price={price}
                    handleSubmitbid={handleSubmitbid}
                    status_check={status_check}
                    handleChange={handleChange}
                    currentIndex={currentIndex}
                    formatNumberToLac={formatNumberToLac}
                    winLoseIconFn={winLoseIconFn}
                    attemptCount={attemptCount}
                    childRef={inputRefs.current[currentIndex]}
                />
            )}
            {imageSlideShow && (
                <ImageSlideModal
                    closeImageSlideShow={imageSlideShowHandler}
                    imageSlideArray={imageData}
                    modalData={modalData}
                />
            )}
            {loading && (
                <ModalWrapper>
                    <Loader />
                </ModalWrapper>
            )}
        </>
    )
}
